import { Component, OnInit, Input } from '@angular/core';
import { NguCarousel } from '@ngu/carousel';

@Component({
  selector: 'app-projects-carousel',
  templateUrl: './projects-carousel.component.html',
  styleUrls: ['./projects-carousel.component.scss']
})
export class ProjectsCarouselComponent implements OnInit {
  @Input('backgroundGray') public backgroundGray;

  public carouselOptions: NguCarousel;
  public automations = [{
    photo: 'assets/images/zz/projects-1.svg',
    text: `Web-платформа для проектирования мебели. Профессиональное мебельное решение для быстрого создания дизайн-проекта, расчета стоимости и производства.`,
    title: 'Binaroom',
	url: 'https://start.binaroom.com/',
  },
  {
    photo: 'assets/images/zz/projects-2.svg',
    text: `Маркетплейс для профессиональных мебельщиков и домашних мастеров, в котором можно заказать мебельные детали индивидуального размера и всю сопутствующую мебельную продукцию.`,
    title: 'Binarti',
    url: 'https://binarti.com/',
  },
  ]
  constructor() { }

  ngOnInit() {
    this.carouselOptions = {
      grid: { xs: 1, sm: 2, md: 3, lg: 3, all: 0 },
      slide: 2,
      speed: 400,
      interval: 4000,
      point: {
        visible: false
      },
      load: 2,
      touch: true,
      loop: true
    }
  }

}
